/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: true, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "Miguel Cano Portfolio",
  description:
    "Desarrollador Full Stack con pasión por crear aplicaciones web desde la idea hasta la implementación. Disfruto trabajando en equipo, resolviendo problemas con soluciones eficientes y escalables. Me especializo en desarrollo frontend y backend, siempre buscando mejorar la experiencia del usuario y la arquitectura del sistema. Además, me encanta compartir conocimientos y colaborar en entornos dinámicos.",
  og: {
    title: "Miguel Cano Portfolio",
    type: "website",
    url: "http://mikalet.com/",
  },
};

//Home Page
const greeting = {
  title: "Miguel Cano Pascual",
  logo_name: "Miguel Cano Pascual",
  nickname: "",
  subTitle:
    "Desarrollador Full Stack con pasión por crear aplicaciones web desde la idea hasta la implementación. Disfruto trabajando en equipo, resolviendo problemas con soluciones eficientes y escalables. Me especializo en desarrollo frontend y backend, siempre buscando mejorar la experiencia del usuario y la arquitectura del sistema. Además, me encanta compartir conocimientos y colaborar en entornos dinámicos.",
  resumeLink:
    "https://drive.google.com/file/d/1bXRknv_h-XI_3CQ3SGPteGODtvEb7YvI/view?usp=sharing",
  portfolio_repository: "/projects",
  githubProfile: "",
};

const socialMediaLinks = [
  {
    name: "LinkedIn",
    link: "https://es.linkedin.com/in/miguel-cano-pascual",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  {
    name: "Gmail",
    link: "mailto:miguelcano0000@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
];

const skills = {
  data: [
    {
      title: "Desarrollador Full Stack ",
      fileName: "FullStackImg",
      skills: [
        "⚡ Desarrollo de interfaces web responsivas con diversas tecnologías.",
        "⚡ Desarrollo de aplicaciones móviles con React Native y aplicaciones Android nativas con Java Android",
        "⚡ Creación de backends para aplicaciones ",
        "⚡ Experiencia trabajando con múltiples plataformas en la nube",
        "⚡ Hospedaje y mantenimiento de sitios web en instancias de máquinas virtuales junto con la integración de bases de datos",
        "⚡ Configuración de trabajos de transmisión de datos entre bases de datos y servidores o viceversa.",
        "⚡ Creación del flujo de funcionalidades de la aplicación para optimizar la experiencia del usuario",
      ],
      softwareSkills: [
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: { color: "#E34F26" },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: { color: "#1572B6" },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#000000",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "Java Android",
          fontAwesomeClassname: "simple-icons:android",
          style: { color: "#3DDC84" },
        },
        {
          skillName: "PHP",
          fontAwesomeClassname: "simple-icons:php",
          style: { color: "#777BB4" },
        },
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: { color: "#61DAFB" },
        },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "devicon-plain:nodejs-wordmark",
          style: { color: "#339933" },
        },
        {
          skillName: "Express",
          fontAwesomeClassname: "simple-icons:express",
          style: { color: "#000000" },
        },
        {
          skillName: "Bootstrap",
          fontAwesomeClassname: "simple-icons:bootstrap",
          style: { color: "#7952B3" },
        },
        {
          skillName: "WordPress",
          fontAwesomeClassname: "simple-icons:wordpress",
          style: { color: "#21759B" },
        },
        {
          skillName: "PrestaShop",
          fontAwesomeClassname: "simple-icons:prestashop",
          style: { color: "#DF0067" },
        },
        {
          skillName: "jQuery",
          fontAwesomeClassname: "simple-icons:jquery",
          style: { color: "#0769AD" },
        },
        {
          skillName: "CodeIgniter",
          fontAwesomeClassname: "simple-icons:codeigniter",
          style: { color: "#EF4223" },
        },
        {
          skillName: "Firebase",
          fontAwesomeClassname: "simple-icons:firebase",
          style: {
            color: "#FFCA28",
          },
        },
        {
          skillName: "Docker",
          fontAwesomeClassname: "simple-icons:docker",
          style: {
            color: "#1488C6",
          },
        },
        {
          skillName: "SQL Server",
          fontAwesomeClassname: "simple-icons:microsoftsqlserver",
          style: {
            color: "#CC2927",
          },
        },
        {
          skillName: "phpMyAdmin",
          fontAwesomeClassname: "simple-icons:phpmyadmin",
          style: {
            color: "#6C78AF",
          },
        },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My projects makes use of vast variety of latest technology tools. My best experience is to create Data Science projects and deploy them to web applications using cloud infrastructure.",
  avatar_image_path: "projects_image.svg",
};



export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  projectsHeader,
};